module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAfklEQVR42uWTwQnAIAxFPXW8DtEFOkAP7tFlHMizqGBNk0IgRSLSQ3voh4cRzONfNABwYa2FATbEELx3E+ScIcbYkFKSklUVUOZ9asDQIp8HsjwRSKIq8N43yLBMFTjneowJQgg08l3OLzUopXzcAPPLBvyZaq096I0uGEUKToYgH/I4zc8HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/x-office-spreadsheet.png
// module id = imgf
// module chunks = 1